import { get, post, put, remove } from "./api";

export const getLabels = async (workspaceId: string, type: string): Promise<any> => {
  const response = await get({
    path: `/workspaces/${workspaceId}/labels/${type}`,
  });
  return { labels: response.data || [], type, workspaceId };
};

export const saveLabel = async (workspaceId: string, formData): Promise<any> => {
  if (formData.id) {
    const response = await put({
      path: `/${workspaceId}/labels/${formData.id}`,
      data: formData,
    });
    return response.data;
  }
  const response = await post({
    path: `/${workspaceId}/labels`,
    data: formData,
  });
  return response.data;
};

export const updateLabel = async (workspaceId: string, labelId, formData): Promise<any> => {
  const response = await put({
    path: `/${workspaceId}/labels/${labelId}`,
    data: formData,
  });
  return response.data;
};

export const deleteLabel = async (workspaceId: string, labelId): Promise<any> => {
  const response = await remove({ path: `/${workspaceId}/labels/${labelId}` });
  return response.data;
};
